import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/* Fetch all roles */
export const getAllRoles = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/admin-roles`);
        return response.data;
    } catch (error) {
        console.error("Error fetching roles:", error);
        throw error;
    }
};

/* Create role */
export const createRole = async (roleData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/admin-roles`, roleData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating role:", error);
        throw error;
    }
};

/* Get role by ID */
export const getRoleById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/admin-roles/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching role with ID ${id}:`, error);
        throw error;
    }
};

/* Update role */
export const updateRole = async (id, roleData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/admin-roles/${id}`, roleData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating role with ID ${id}:`, error);
        throw error;
    }
};

/* Delete role */
export const deleteRole = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/admin-roles/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting role with ID ${id}:`, error);
        throw error;
    }
};